import { getUUID } from '@laborability/commons';
import { atom } from 'recoil';

export const appBarState = atom<string | undefined>({
  key: getUUID(),
  default: undefined,
});
